/*
 * SS-CUSTOM: card-quantity
 * Steppers on collection cards, with the coverage figure counting up.
 *
 * Coverage sits on the stepper row, to the right of the controls. It started
 * on its own line (a wasted row on every card), then moved into the price row,
 * where a card is only 237px wide and a struck-through compare-at price already
 * competes for space: past a couple of packs "Covers 25.60m2" pushed the
 * compare-at price onto a second line. The stepper row has the width, costs no
 * extra row, and puts the figure next to the control that changes it.
 *
 * Delegated from the document so cards swapped in by facet filtering or
 * pagination keep working without re-binding.
 */
(function () {
  'use strict';

  var FORMAT = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  function paint(input) {
    var qty = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = qty;

    var card = input.closest('.card-wrapper');
    if (!card) return;

    // Coverage lives beside the stepper. Only the figure is rewritten, so the
    // word "Covers" keeps its muted styling and nothing reflows around it.
    var area = parseFloat(input.dataset.packArea);
    var figure = card.querySelector('[data-ss-qty-area]');
    if (figure && area > 0) {
      figure.textContent = (qty * area).toFixed(2) + 'm²';
    }

    // the button carries the running total, so the cost of the choice is on
    // the control that commits to it
    var label = card.querySelector('[data-ss-qty-total]');
    var cents = parseInt(input.dataset.packPrice, 10);
    if (label && cents > 0) {
      label.textContent = ' · ' + FORMAT.format((qty * cents) / 100);
    }
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-ss-qty-step]');
    if (!step) return;

    // the stepper lives inside the add-to-cart form, so a stray submit would
    // add the product instead of changing its quantity
    event.preventDefault();

    var wrapper = step.closest('[data-ss-card-qty]');
    var input = wrapper && wrapper.querySelector('[data-ss-qty-input]');
    if (!input) return;

    var delta = parseInt(step.dataset.ssQtyStep, 10) || 0;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    paint(input);
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-ss-qty-input]');
    if (input) paint(input);
  });

  // guard against an empty box being submitted as a blank quantity
  document.addEventListener(
    'blur',
    function (event) {
      var input = event.target.closest('[data-ss-qty-input]');
      if (input) paint(input);
    },
    true
  );
})();
